// Wire the burger drawer's in-panel close button (.menu-drawer__close-button) to the EXISTING
// vendored close path. assets/global.js (HeaderDrawer) already binds a click handler on
// `.header-drawer-overlay` that calls `closeMenuDrawer(event)` (which unlocks scroll + resets
// aria/focus). Re-using that path keeps the close behaviour identical to tapping the scrim — no
// edit to the vendored JS, and no half-close (the generic MenuDrawer button handler only runs
// closeSubmenu, which would leave the page scroll locked).
//
// Delegated so it survives section re-renders in the theme editor.
function onDocumentClick(event) {
  const closeBtn = event.target.closest('.menu-drawer__close-button');
  if (!closeBtn) return;
  if (!closeBtn.closest('header-drawer')) return;

  const overlay = document.querySelector('.header-drawer-overlay');
  if (overlay) {
    overlay.click(); // → HeaderDrawer.closeMenuDrawer(event)
    return;
  }

  // Fallback: toggle the main <summary> (also routes through closeMenuDrawer when open).
  const summary = closeBtn.closest('header-drawer').querySelector('summary');
  if (summary) summary.click();
}

export default function initHeaderDrawerClose() {
  document.addEventListener('click', onDocumentClick);
}

// Self-initialising side-effect import (matches the sibling modules in this folder).
initHeaderDrawerClose();
